import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  interview: {},
  loading: false,
};

function onLoad(state) {
  return { ...state, loading: true };
}

function onLoadSuccess(state, { payload }) {
  return {
    ...state,
    interview: payload,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
});
